import React, { useCallback, memo } from 'react';
import { Select } from '@leasequery/lq.react-component-library';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ClientCustomCalendarModel, ReportCurrency } from '../../../models';
import * as Styled from './styled';
import { buildDropdownList } from './helpers/buildReportSettingData';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingFiscallRollforwardProps {
  onChange: (updatedValue: ReportSettingFiscalRollforwardState) => void;
  reportSettingState: ReportSettingFiscalRollforwardState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
  customCalendarSettings?: ClientCustomCalendarModel;
}

export interface ReportSettingFiscalRollforwardState {
  selectedCurrency: SelectOption<ReportCurrency>;
  startDate: string;
  rollforwardThrough: string;
  selectedFiscalStartMonth: SelectOption<string>;
  isValid: boolean;
}

function ReportSettingRollforward({
  onChange,
  reportSettingState,
  reportTypeSetting,
}: ReportSettingFiscallRollforwardProps): JSX.Element {
  const fiscalStartMonthList = buildDropdownList(
    'Fiscal Rollforward',
    'FiscalStartMonth',
    reportTypeSetting,
  );
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
      <Styled.DropdownBar>
        <div>
          <Icon name="calendar" />
        </div>
        <Select
          placeholder="Fiscal Start Month"
          label="Fiscal Start Month"
          name="fiscalStartMonth"
          options={fiscalStartMonthList}
          onChange={useCallback(
            (option: SelectOption<string>): void => {
              onChange({
                ...reportSettingState,
                selectedFiscalStartMonth: option,
              });
            },
            [onChange, reportSettingState],
          )}
          value={reportSettingState.selectedFiscalStartMonth}
        />
      </Styled.DropdownBar>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingRollforward);
